import React from 'react';

const BottomFooter = () => {
  const policies = [
    { name: 'Privacy Policy', href: '#' },
    { name: 'Terms of Service', href: '#' },
    { name: 'Cookie Policy', href: '#' },
  ];

  return (
    <div className="py-6 border-t border-gray-800">
      <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
        <div className="text-sm">
          © 2024 Adventure Scanner. All rights reserved.
        </div>
        <div className="flex space-x-6 text-sm">
          {policies.map((policy, index) => (
            <a key={index} href={policy.href} className="hover:text-white transition">
              {policy.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BottomFooter;